/**
 * Enhanced Argentina Province Detection System
 * Uses multiple detection methods including Google Analytics, IP geolocation, and browser data
 */

// Amplitude tracking removed

// Cache for province detection to prevent excessive loops
const PROVINCE_CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

// Argentina Province Codes and Names
export const ARGENTINA_PROVINCES = {
  // Major Provinces with timezone support
  "BA": { name: "Buenos Aires", timezone: "America/Argentina/Buenos_Aires", population: 17594428 },
  "CB": { name: "Córdoba", timezone: "America/Argentina/Cordoba", population: 3760450 },
  "MZ": { name: "Mendoza", timezone: "America/Argentina/Mendoza", population: 1990338 },
  "TM": { name: "Tucumán", timezone: "America/Argentina/Tucuman", population: 1687305 },
  "SA": { name: "Salta", timezone: "America/Argentina/Salta", population: 1440672 },
  "JY": { name: "Jujuy", timezone: "America/Argentina/Jujuy", population: 797955 },
  "SJ": { name: "San Juan", timezone: "America/Argentina/San_Juan", population: 818234 },
  "SL": { name: "San Luis", timezone: "America/Argentina/San_Luis", population: 508328 },
  "CT": { name: "Catamarca", timezone: "America/Argentina/Catamarca", population: 429556 },
  "LR": { name: "La Rioja", timezone: "America/Argentina/La_Rioja", population: 384607 },
  "TF": { name: "Tierra del Fuego", timezone: "America/Argentina/Ushuaia", population: 190641 },
  
  // Additional provinces (use Buenos Aires timezone as fallback)
  "SF": { name: "Santa Fe", timezone: "America/Argentina/Buenos_Aires", population: 3397532 },
  "ER": { name: "Entre Ríos", timezone: "America/Argentina/Buenos_Aires", population: 1426426 },
  "CR": { name: "Corrientes", timezone: "America/Argentina/Buenos_Aires", population: 1197553 },
  "MI": { name: "Misiones", timezone: "America/Argentina/Buenos_Aires", population: 1280960 },
  "CH": { name: "Chaco", timezone: "America/Argentina/Buenos_Aires", population: 1204541 },
  "FO": { name: "Formosa", timezone: "America/Argentina/Buenos_Aires", population: 606041 },
  "ST": { name: "Santiago del Estero", timezone: "America/Argentina/Buenos_Aires", population: 978313 },
  "RN": { name: "Río Negro", timezone: "America/Argentina/Buenos_Aires", population: 747610 },
  "NQ": { name: "Neuquén", timezone: "America/Argentina/Buenos_Aires", population: 664057 },
  "CHU": { name: "Chubut", timezone: "America/Argentina/Buenos_Aires", population: 618994 },
  "SC": { name: "Santa Cruz", timezone: "America/Argentina/Buenos_Aires", population: 374756 },
  "LP": { name: "La Pampa", timezone: "America/Argentina/Buenos_Aires", population: 358428 }
} as const;

/**
 * Get province name from code
 */
export function getProvinceName(code: string): string {
  return ARGENTINA_PROVINCES[code as keyof typeof ARGENTINA_PROVINCES]?.name || code;
}

/**
 * Get all provinces
 */
export function getAllProvinces() {
  return ARGENTINA_PROVINCES;
}

export default {
  ARGENTINA_PROVINCES,
  getProvinceName,
  getAllProvinces,
};
